export default class Base {
    constructor(item) {
        this.handleProperties(item);
    }

    handleProperties(item) {
        // copy properties
        for (let key in item) {
            this[key] = item[key];
        }
    }

    clone() {
        return new this.constructor(this);
    }

    update(data) {
        for (let key in data) {
            if (this[key]?.update) {
                this[key].update(data[key]);
            } else {
                this[key] = data[key];
            }
        }

        return this;
    }
}
